import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import logoutIcon from "assets/icons/logout.svg";

const LogoutButton = () => {
  const { logout } = useAuth0();

  const handleLogout = () => {
    // Clear filter state from localStorage before logout
    localStorage.removeItem('recipe_filters');
    
    // Clear Auth0 cache from localStorage to prevent automatic re-login
    // This ensures users see the account chooser prompt on next login
    const keysToRemove = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      // Remove Auth0 keys (typically prefixed with @@auth0spajs@@)
      if (key && key.includes('@@auth0')) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach(key => localStorage.removeItem(key));
    
    // Log out locally (don't federated logout to avoid logging out of Google entirely)
    logout({ 
      logoutParams: { 
        returnTo: window.location.origin,
        localOnly: true  // Explicitly local-only to avoid federated logout
      } 
    });
  };

  return (
    <div className="nav-btn-container">
      <div
        className="nav-btn logout-btn"
        onClick={handleLogout}
      >
        <img className="btn-icon log-out-btn-icon" src={logoutIcon} />
        <div className="log-out-btn-text">Log out</div>
      </div>
    </div>
  );
};

export default LogoutButton;
